export const text = {
  CONFIRM_DELETION_MESSAGE:
    'Please confirm you wish to cancel this visit. Cancellation will not apply visit credit or cancellation fee to this patient.',
  RECURRENCE_DELETION_CONFIRM_MESSAGE:
    'This time period is part of a recurring event. Do you wish to delete this single event or all future events? Deletion does not cancel patients who previously booked during this event.',
  RECURRENCE_DELETION_PRIMARY_BUTTON: 'This and following events',
  RECURRENCE_DELETION_SECONDARY_BUTTON: 'This event only',
}

export const styles = {
  RECURRENCE_SCHEDULE_STYLE: { marginTop: 24 },
}
